<script>
import SearchResultsTabStores from '@phoenix/mixins/components/search/SearchResultsTabStores';
import SearchResultsTab from '../search/SearchResultsTab';
import { IndexNames } from '@module/Algolia/resources/js/search/AlgoliaSearch';
import { algoliaTracking } from '@module/Algolia/resources/js/insights/helpers';
import SearchStoreCard from '@maison/components/search/SearchStoreCard.vue';

export default {
  components: {
    SearchStoreCard,
    SearchResultsTab,
  },

  mixins: [SearchResultsTabStores],

  props: {
    uniqueId: {
      type: String,
      default: '',
    },
  },

  methods: {
    onStoreClick(store, position) {
      algoliaTracking(store, position, IndexNames.Stores);
    },
  },
};
</script>

<template>
  <search-results-tab :tab="tab" :limit="limit">
    <search-store-card
      v-for="(store, index) in items"
      :key="store.id"
      v-bind="store"
      :data-tracking="dataTracking"
      @click="onStoreClick(store, index)"
    />
  </search-results-tab>
</template>
